export default {
  fixed: 'USTALONE',
  variable: 'Zmienny',
};
